module.exports = __webpack_public_path__ + "static/img/200088.1783aa48.png";